import { useState } from 'react'
import { Tabs, Tab, KpiCard, Alert } from '@/components/ui'
import { Camera, Clock, DollarSign, Percent, XCircle, FileSearch, History, BarChart3, Shield } from 'lucide-react'
import { Pendientes } from './Pendientes'
import { Historico } from './Historico'
import { Kpis } from './Kpis'
import { Antifraude } from './Antifraude'

type TabKey = 'pendientes' | 'historico' | 'kpis' | 'antifraude'

export function RevisionPage() {
  const [tab, setTab] = useState<TabKey>('pendientes')

  return (
    <div className="space-y-5">
      <header>
        <div className="text-xs uppercase tracking-widest text-rose-500 font-semibold">WhatsApp · Revisión</div>
        <h1 className="font-display text-3xl text-navy-700 leading-tight flex items-center gap-3">
          <Camera className="w-7 h-7 text-rose-500" /> Comprobantes y transferencias
        </h1>
        <p className="text-sm text-slate-500 max-w-2xl mt-1">
          Comprobantes que la IA no validó al 100% — requieren ojo humano. Edición inline, acumulado del cliente y config anti-fraude.
        </p>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        <KpiCard
          label="Pendientes revisión"
          value={<span>3 <span className="relative inline-flex ml-1"><span className="w-2 h-2 rounded-full bg-rose-500 absolute animate-ping" /><span className="w-2 h-2 rounded-full bg-rose-500 relative" /></span></span>}
          sub="1 urgente"
          icon={<Clock className="w-3.5 h-3.5" />}
          color="amber"
        />
        <KpiCard label="Validados hoy" value="54" sub="↑ +12%" icon={<FileSearch className="w-3.5 h-3.5" />} color="emerald" />
        <KpiCard label="Monto validado hoy" value="$8,921" sub="USD · total" icon={<DollarSign className="w-3.5 h-3.5" />} />
        <KpiCard label="Tasa auto IA" value="82%" sub="sin humano" icon={<Percent className="w-3.5 h-3.5" />} color="emerald" />
        <KpiCard label="Rechazados hoy" value="6" sub="anti-fraude ok" icon={<XCircle className="w-3.5 h-3.5" />} color="rose" />
      </div>

      <Alert variant="warning" title="1 urgente">
        Patricio Sumbaña espera revisión hace 2h 15min. Priorizá.
      </Alert>

      <Tabs value={tab} onChange={v => setTab(v as TabKey)} color="rose">
        <Tab value="pendientes" icon={<FileSearch className="w-4 h-4" />} badge={<span className="ml-1 bg-rose-500 text-white text-[9px] px-1.5 py-0.5 rounded-full">3</span>}>Pendientes</Tab>
        <Tab value="historico" icon={<History className="w-4 h-4" />}>Histórico</Tab>
        <Tab value="kpis" icon={<BarChart3 className="w-4 h-4" />}>KPIs</Tab>
        <Tab value="antifraude" icon={<Shield className="w-4 h-4" />}>Anti-fraude</Tab>
      </Tabs>

      <div className="view-transition">
        {tab === 'pendientes' && <Pendientes />}
        {tab === 'historico' && <Historico />}
        {tab === 'kpis' && <Kpis />}
        {tab === 'antifraude' && <Antifraude />}
      </div>
    </div>
  )
}
